<template>
  <v-layout class="px-3" column justify-start align-center fill-height style="margin-top: 80px">
    <div class="width-100">
      <v-fade-transition>
        <v-layout justify-center v-if="ready">
          <v-card class="rounded-5" width="100%" max-width="500px">
            <v-card-title class="justify-center font-weight-black">로그인</v-card-title>
            <v-card-subtitle class="text-center">
              아이디와 비밀번호를 입력하여 로그인해주세요.
            </v-card-subtitle>

            <v-card-text>
              <v-form @submit.prevent="signin(user)">
                <v-text-field
                  v-model="user.email"
                  label="이메일"
                  outlined
                  dense
                  :error="!!invalidMsg.email"
                  :rules="rules.email"
                  autofocus
                  autocomplete="email"
                ></v-text-field>

                <v-text-field
                  type="password"
                  v-model="user.password"
                  label="비밀번호"
                  outlined
                  dense
                  :error="!!invalidMsg.password"
                  :rules="rules.password"
                  autocomplete="current-password"
                ></v-text-field>

                <BasicButton
                  type="submit"
                  block
                  depressed
                  height="46"
                  :disabled="signinLoading || !isValidAll"
                  :loading="signinLoading"
                >
                  로그인
                </BasicButton>
              </v-form>
            </v-card-text>

            <v-card-actions class="pa-4">
              <v-layout justify-space-between align-center>
                <span class="font--m-5 color--nice-grey">계정이 없으신가요?</span>
                <v-btn :to="{ name: 'signup' }" color="primary" class="px-0" depressed text>
                  회원가입
                </v-btn>
              </v-layout>
            </v-card-actions>

            <!-- 기본 플랫폼인 경우에만 카카오 로그인 버튼 표시 -->
            <template v-if="isDefaultPlatform">
              <v-divider class="my-4"></v-divider>
              <v-card-text>
                <KakaoButton @signinSuccess="signinSuccess" />
              </v-card-text>
            </template>
          </v-card>
        </v-layout>
      </v-fade-transition>
    </div>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { getRedirectUriAndRemove, sleep } from '@/util'
import Regex from '@/const/Regex'
import { redirectSignupManage } from '@/util/signupManage'

export default {
  components: {
    KakaoButton: () => import('@/components/signup/KakaoButton.vue'),
  },
  data() {
    return {
      user: {
        email: '',
        password: '',
      },
      signinLoading: false,
      invalidMsg: {
        email: null,
        password: null,
      },
      rules: {
        email: [
          (value) => !!value || '메일 주소를 입력해주세요.',
          (value) => Regex.EMAIL.REGEX.test(value) || Regex.EMAIL.MSG,
        ],
        password: [
          (value) => !!value || '패스워드를 입력해주세요',
          (value) => value.length > 5 || '패스워드는 6자리 이상이어야 합니다.',
        ],
      },
      emailIsValid: false,
      passwordIsValid: false,
      ready: false,
    }
  },
  async mounted() {
    await sleep(200)
    this.ready = true
  },
  computed: {
    isValidAll() {
      return this.emailIsValid && this.passwordIsValid
    },
    ...mapGetters('myfinbiz', ['isDefaultPlatform']),
  },
  watch: {
    'user.email'(email) {
      this.emailValidate(email)
    },
    'user.password'(password) {
      this.passwordValidate(password)
    },
  },
  methods: {
    ...mapMutations('status', ['refresh']),
    ...mapActions('auth', ['signinIdPassword']),
    getFormErrMsg(type, newVal) {
      const rules = this.rules[type]
      let msg = null
      for (let index = 0; index < rules.length; index++) {
        const rule = rules[index]
        const isValid = rule(newVal)
        if (typeof isValid !== 'boolean') {
          msg = isValid
          break
        }
      }

      this.invalidMsg[type] = msg
      return msg
    },
    emailValidate(email) {
      const msg = this.getFormErrMsg('email', email)
      if (msg === null) {
        this.emailIsValid = true
      } else {
        this.emailIsValid = false
      }
    },
    passwordValidate(password) {
      const msg = this.getFormErrMsg('password', password)
      if (msg === null) {
        this.passwordIsValid = true
      } else {
        this.passwordIsValid = false
      }
    },
    async movePage() {
      let redirectUri = getRedirectUriAndRemove()
      if (!redirectUri) {
        redirectUri = '/'
      }

      if (await redirectSignupManage()) {
        return
      }

      await this.$router.replace(redirectUri)
    },
    async signin(user) {
      try {
        this.signinLoading = true
        await this.signinIdPassword(user)
        await this.movePage()
      } catch (e) {
        if (e.status === 400) {
          this.user.password = ''
        }
        throw e
      } finally {
        this.signinLoading = false
      }
    },
    async signinSuccess() {
      this.refresh()
      await this.movePage()
    },
  },
}
</script>
